import { useCefFilterStore } from '@/stores/cefFilter'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import useAuthUser from '@/composables/useAuthUser'
import useChannel from '@/composables/useChannel'
import useServices from '@/composables/useServices'
import useState from '@/composables/useState'

const useCefFilter = (params: { [key: string]: any }) => {
	const { user } = useAuthUser()

	const { selectedCompany } = storeToRefs(useCefFilterStore())

	const { services } = useServices()
	const { channels } = useChannel()
	const { states } = useState()

	const filterNames: Record<string, string> = {
		travelerName: 'Nombre del viajero',
		confirmation: 'Confirmación',
		name: 'Nombre itinerario',
		company: 'Empresa',
		status: 'Estatus',
		progressStage: 'Etapa de progreso',
		order: 'Orden',
		creatorName: 'Creador',
		service: 'Servicio',
		channel: 'Canal',
		folio: 'Folio',
		hasLetter: 'Tiene carta',
		dates: 'Fechas de viaje ',
		creationDates: 'Fechas de creación',
		supplierName: 'Proveedor',
		tripReason: 'Motivo de viaje',
		cef: 'CEF',
	}

	const valueMap: Record<string, Record<any, string>> = {
		status: {
			0: 'Todos',
		},
		progressStage: {
			current: 'En curso',
			past: 'Anteriores',
			future: 'Proximos',
		},

		hasLetter: {
			1: 'Con carta garantía',
			0: 'Sin carta garantía',
			Todos: 'Sin orden',
		},
		order: {
			asc: 'Más antiguo',
			desc: 'Más reciente',
			Todos: 'Sin orden',
		},
	}

	const getFiltersValue = (key: string, value: any) => {
		if (value === null || value === undefined) {
			return null
		}

		if (key === 'service') {
			return services.value.find((service) => service.id === value)?.displayName
		}
		if (key === 'channel') {
			return channels.value.find((channel) => channel.id === value)?.name
		}
		if (key === 'progressStage') {
			return valueMap[key][value] ?? value
		}
		if (key === 'status') {
			return states.value.find((state) => state.id === value)?.displayName
		}
		if (key === 'hasLetter') {
			return valueMap[key][value] ?? value
		}
		if (key === 'order') {
			return valueMap[key][value] ?? value
		}
		if (key === 'creationDates') {
			return value
				.map((date: string) => new Date(date).toLocaleDateString())
				.join(' - ')
		}
		if (key === 'dates') {
			return value
				.map((date: string) => new Date(date).toLocaleDateString())
				.join(' - ')
		}
		if (key === 'company') {
			return selectedCompany.value?.name
		}
		return value
	}

	const activeFilters = computed(() => {
		return Object.entries(params)
			.map(([key, value]) => {
				return {
					reference: key,
					key: filterNames[key],
					value: getFiltersValue(key, value),
				}
			})
			.filter(
				({ value }) =>
					value !== '' &&
					value !== null &&
					value !== undefined &&
					value !== 0 &&
					(!Array.isArray(value) || value.length > 0)
			)
			.filter((filter) => {
				if (filter!.reference === 'order' && filter!.value === 'Más reciente')
					return false
				if (filter!.reference === 'progressStage') return false
				if (filter!.reference === 'onlyRequests') return false
				if (filter!.reference === 'status' && filter!.value === 3) {
					return false
				}
				if (filter!.reference === 'page') return false
				if (filter!.reference === 'perPage') return false

				return true
			})
	})

	return {
		activeFilters,
	}
}

export default useCefFilter
